var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountAssignment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.43 198.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M19.55 85.89L38.2 61.26M38.2 85.89L19.55 61.26M45.61 85.89l18.65-24.63M64.26 85.89L45.61 61.26M70.69 85.89l18.65-24.63M89.34 85.89L70.69 61.26M112.34 61.29l9.31 12.34 9.34-12.34M121.63 85.88V73.1M136.45 61.29l9.3 12.34 9.34-12.34M145.73 85.88V73.1M160.22 61.29l9.31 12.34 9.34-12.34M169.51 85.88V73.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M101.09 52.81v40.07"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountAssignment);
export default __webpack_public_path__ + "static/media/accountAssignment.8c9085ddc18bdca3541c80ae55b1cb82.svg";
export { ForwardRef as ReactComponent };